module.exports = __webpack_public_path__ + "static/media/zombie.d43b6334.jpg";